<template>
  <div id="container"></div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import { bd09ToGcj02, wgs84ToGcj02 } from '../utils/coordConvert.js'

export default {
  name: "GaodeContainer",
  props: {
    // 格式: [[lng, lat, title, color], ...]
    defaultData: {
      type: Array,
      default: () => []
    },
    cityName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      AMap: null,
      map: null
    };
  },
  mounted() {
    this.initAMap();
  },
  unmounted() {
    if (this.map) {
      this.map.destroy();
    }
  },
  watch: {
    cityName(newVal) {
      if (newVal) {
        this.gotoCity(newVal);
      }
    }
  },
  methods: {
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "c2bf28938e03b4c62e236436f3747da0" // 👈 替换为你自己的安全密钥
      };

      AMapLoader.load({
        key: "bdfdcd1e62e20e2d27d027d457c9463e", // 👈 替换为你自己的高德 Key
        version: "2.0",
        plugins: ["AMap.Scale", "AMap.Geocoder"]
      })
        .then((AMap) => {
          this.AMap = AMap;
          this.map = new AMap.Map("container", {
            viewMode: "3D",
            zoom: 11,
            center: [116.397428, 39.90923]
          });

          this.map.addControl(new AMap.Scale());
          this.addOverlay(this.defaultData);
        })
        .catch((e) => {
          console.error("高德地图加载失败:", e);
        });
    },

    clearMap() {
      if (this.map) {
        this.map.clearMap();
      }
    },

    addOverlay(array) {
      this.clearMap();
      for (const item of array) {
        this.addPosition(item);
      }
    },

    removeOverlay(array) {
      const titlesToRemove = array.map(item => item[2]);
      const allMarkers = this.map.getAllOverlays("marker");
      const toRemove = allMarkers.filter(marker =>
        titlesToRemove.includes(marker.getTitle())
      );
      this.map.remove(toRemove);
    },

    addPosition(item) {
      let [lng, lat, title, color = "#000"] = item;
      if (item[4] === 'BD-09') {
        [lng, lat] = bd09ToGcj02(lng, lat);
      } else if (item[4] === 'WGS-84') {
        var pos = wgs84ToGcj02(lng, lat);
        lng = pos.lon;
        lat = pos.lat;
      }
      // GCJ-02: 高德地图原生支持，直接使用坐标

      // 构建带颜色的自定义文本标签
      const labelDiv = document.createElement("div");
      labelDiv.innerHTML = `<div style="
        color: ${color};
        font-size: 13px;
        padding: 4px 8px;
        background: #ffffff;
        border: 1px solid #ccc;
        border-radius: 4px;
        white-space: nowrap;
        font-family: 'Microsoft YaHei', sans-serif;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">${this.$options.filters?.escapeHtml ? this.$options.filters.escapeHtml(title) : title}</div>`;

      // 创建 Marker，使用 content 渲染自定义 DOM
      const marker = new this.AMap.Marker({
        position: [lng, lat],
        title: title, // 用于识别删除
        offset: new this.AMap.Pixel(-labelDiv.firstElementChild.offsetWidth / 2 || -30, -30),
        content: labelDiv,
        // 禁用拖拽、点击等（可选）
        draggable: false,
        cursor: "default"
      });

      this.map.add(marker);
    },

    gotoCity(cityName) {
      if (!this.AMap || !this.map) {
        console.warn("地图未初始化");
        return;
      }

      const geocoder = new this.AMap.Geocoder({ city: cityName });
      geocoder.getLocation(cityName, (status, result) => {
        if (status === "complete" && result.geocodes.length > 0) {
          const location = result.geocodes[0].location;
          this.map.setCenter(location);
          this.map.setZoom(12);
        } else {
          console.error(`无法定位城市: ${cityName}`);
        }
      });
    }
  }
};
</script>

<style scoped>
#container {
  width: 100%;
  height: 800px;
}
</style>